import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArScanCube1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArScanCube1"><Path fillRule="evenodd" clipRule="evenodd" d="M3 21L3 15H5V19H9V21H3ZM3 9V3H9V5H5V9H3ZM15 19H19V15H21V21H15V19ZM15 3H21V9H19V5H15V3Z" fill="currentColor"/><Path d="M8.50002 8.84826L12 6.84827L15.5 8.84826L12 10.8482L8.50002 8.84826Z" fill="currentColor"/><Path d="M7.5 10.5803V14.5803L11 16.5803V12.5803L7.5 10.5803Z" fill="currentColor"/><Path d="M13 16.5803L16.5 14.5803V10.5803L13 12.5803V16.5803Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArScanCube1;
